<template>
  <el-dialog class="comp-reword-config" title="转发悬赏" :visible.sync="visible" @close="close">
    <div class="desc">温馨提示：系统通过大数据技术将企业转发悬赏招聘岗位信息推送给用户，用户通过扩散转发来帮助企业提升招聘曝光量，最后企业根据转发次数结算佣金。</div>
    <div class="content-box">
      <div class="content-item flex align-start">
        <div class="left-tit">请选择转发模式</div>
        <div class="right-content">
          <div class="mode flex">
            <el-radio class="radio" v-model="type" :label="1">全体转发</el-radio>
            <span class="sub-text">全体用户均可参与，曝光范围广</span>
          </div>
          <div class="mode">
            <el-radio disabled class="radio" v-model="type" :label="2">精准转发</el-radio>
            <span class="sub-text">仅求职期望一致的用户转发有效，曝光群体更精准</span>
          </div>
        </div>
      </div>

      <div class="content-item flex align-start">
        <div class="left-tit">单个用户浏览佣金</div>
        <div class="right-content">
          <div class="sub-text">转发的岗位在被其他人查看后，转发人将获得的相应的佣金</div>
          <div><el-input-number class="input-amount" v-model="singleAmount" :min="0.1" :max="1000" /><span class="unit">元</span></div>
          <div class="sub-text">单次浏览最低0.1元起/精准转发最低2.0起，转发访问单个用户重复浏览不计算费用</div>
        </div>
      </div>
      <div class="content-item flex align-start">
        <div class="left-tit">转发悬赏结束日期</div>
        <div class="right-content">
          <el-date-picker v-model="planEndAt" type="date" placeholder="选择日期" :picker-options="pickerOptions0" format="yyyy-MM-dd"></el-date-picker>
          <span class="sub-text">选择的日期晚上12点过后结束悬赏结算</span>
        </div>
      </div>
      <div class="content-item flex align-start">
        <div class="left-tit">转发悬赏总预算</div>
        <div class="right-content">
          <div>
            <el-input class="input-amount-2" v-model="amount" placeholder="请输入转发预算总金额" />
            <span class="unit">元</span>
          </div>
        </div>
      </div>
      <div class="content-item flex align-start">
        <div class="left-tit">预算超支控制</div>
        <div class="right-content">
          <div class="flex">
            <el-radio class="radio" v-model="overspend" :label="1">允许超支</el-radio>
            <el-radio class="radio" v-model="overspend" :label="0">不允许超支</el-radio>
          </div>
          <span class="sub-text m-t-13">允许超支将会在可用余额用完时停止发放佣金</span>
        </div>
      </div>

      <el-button class="btn" @click="submit">确定开通转发悬赏</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      id: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        type: 1,
        singleAmount: 1,
        planEndAt: '',
        amount: '',
        overspend: 1,
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      }
    },
    watch: {
      show: {
        handler(val) {
          this.visible = val
        },
        immediate: true
      }
    },
    methods: {
      close() {
        this.$emit('update:show', false)
        },
      submit() {
        this.validate().then(() => {
          const saveRewardParam = {
            type: this.type,
            singleAmount: this.singleAmount,
            startAt: this.getCurrentDate(),
            planEndAt: this.getCurrentDate(this.planEndAt),
            amount: this.amount,
            overspend: this.overspend,
            recruitId: this.id
          }
          console.log('saveRewardParam', saveRewardParam)
          this.axios.post('/wapi/hr/recruit/save/reward', saveRewardParam).then(res => {
            console.log('res', res)
            if (res.status === 200) {
              this.$message.success('开通成功')
              this.$emit('refresh')
              this.close()
            }
          })
        })
      },
      validate() {
        return new Promise((resolve, reject) => {
          if (!this.planEndAt) {
            this.$message.warning('请选择转发悬赏结束日期')
            reject('请选择转发悬赏结束日期')
          }
          if (!this.amount) {
            this.$message.warning('请输入转发悬赏总预算')
            reject('请输入转发悬赏总预算')
          }

          resolve()
        })
      },
      getCurrentDate(dataString) {
        const now = dataString ? new Date(dataString) : new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    },
  }
</script>

<style lang="less" scoped>
@import '~@/assets/less/base.less';

.comp-reword-config {
  /deep/ .el-dialog {
    width: 776px;
    // height: 699px;
    background: linear-gradient(133deg, rgba(212, 236, 254, 1) 0%, rgba(255, 255, 255, 1) 100%);
    border-radius: 12px;
    .el-dialog__title {
      font-weight: bold;
      font-size: 24px;
      color: rgba(0,0,0,0.85);
      line-height: 28px;
    }
    .el-dialog__close {
      color: #333333;
    }
    .el-dialog__body {
      padding: 12px 24px 24px 24px;
    }
  }
  .desc {
    font-size: 16px;
    color: rgba(4,15,36,0.65);
    line-height: 26px;
    margin-bottom: 14px;
  }
  .content-box {
    background-color: rgba(255, 255, 255, 1);
    padding: 18px 24px;
    border-radius: 7px;
    .content-item {
      margin-bottom: 24px;
    }
    .btn {
      width: 225px;
      height: 48px;
      background: linear-gradient( 90deg, #057CF9 0%, #1AAFFD 100%);
      // border-radius: 4px;
      display: block;
      margin: 0 auto;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
    }
  }
  .left-tit {
    width: 144px;
    font-weight: 500;
    font-size: 16px;
    color: #040F24;
    line-height: 22px;
  }
  .right-content {
    flex: 1;
    .sub-text {
      font-size: 12px;
      color: rgba(85,85,85,0.75);
      line-height: 17px;
    }
    .mode {
      margin-bottom: 10px;
    }
    .input-amount {
      margin: 10px 0;
    }
    .input-amount-2 {
      width: 184px;
    }
    .unit {
      font-size: 16px;
      color: #333333;
      margin-left: 8px;
    }
    .m-t-13 {
      margin-top: 13px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Config.vue?8b097746